import logo1 from "../../../Assets/Home/logo1.svg";
import logo2 from "../../../Assets/Home/logo2.svg";
import logo3 from "../../../Assets/Home/logo3.svg";
import logo4 from "../../../Assets/Home/logo4.svg";
import logo5 from "../../../Assets/Home/logo5.svg";
import logo6 from "../../../Assets/Home/logo6.svg";
import logo7 from "../../../Assets/Home/logo7.svg";
import logo8 from "../../../Assets/Home/logo8.svg";

export default function MixMastersPartners() {
  const partners = [
    { id: 1, logo: logo1 },
    { id: 2, logo: logo2 },
    { id: 3, logo: logo3 },
    { id: 4, logo: logo4 },
    { id: 5, logo: logo5 },
    { id: 6, logo: logo6 },
    { id: 7, logo: logo7 },
    { id: 8, logo: logo8 },
  ];

  const allPartners = [...partners, ...partners, ...partners];

  return (
    <div className="w-full bg-white py-10 overflow-hidden">
      {/* Label */}
      <div className="text-center mb-6">
        <span className="text-[#c020d0] text-xs font-semibold tracking-[0.22em] uppercase">
          [Strategic Partner]
        </span>
      </div>

      {/* Wrapper */}
      <div className="relative w-full overflow-hidden">
        {/* Left Fade */}
        <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" />

        {/* Right Fade */}
        <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" />

        {/* Logo Track */}
        <div className="flex gap-10 w-max animate-scroll-left px-10 hover:[animation-play-state:paused]">
          {allPartners.map((p, i) => (
            <div
              key={`${p.id}-${i}`}
              className="flex items-center justify-center w-[120px] h-[90px] bg-white rounded-xl shadow-sm transition-all duration-300 hover:scale-105 hover:shadow-lg flex-shrink-0"
            >
              <img
                src={p.logo}
                alt="partner-logo"
                className="max-h-20 object-cover"
              />
            </div>
          ))}
        </div>
      </div>

      {/* Tailwind Animation */}
      <style>
        {`
       @keyframes scroll-left {
  0% { transform: translateX(0); }
  100% { transform: translateX(-33.333%); }
}

@keyframes scroll-right {
  0% { transform: translateX(-33.333%); }
  100% { transform: translateX(0); }
}

.animate-scroll-left {
  animation: scroll-left 20s linear infinite;
}

.animate-scroll-right {
  animation: scroll-right 30s linear infinite;
}
        `}
      </style>
    </div>
  );
}
